import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/Button';
import Card from '../components/Card';

function Introduction() {
  const navigate = useNavigate();

  const features = [
    {
      icon: '🤖',
      title: 'BridgeBot Chat',
      description: 'Get 24/7 support from our AI wellness assistant'
    },
    {
      icon: '🎯',
      title: 'Daily Quests',
      description: 'Complete fun challenges to build healthy habits'
    },
    {
      icon: '🧘',
      title: 'Mindfulness Tools',
      description: 'Guided breathing and meditation exercises'
    },
    {
      icon: '🤝',
      title: 'Peer Support',
      description: 'Connect with others who understand your journey'
    }
  ];

  return (
    <div style={{ 
      maxWidth: '480px', 
      margin: 'auto', 
      padding: '20px', 
      backgroundColor: '#f5f7fa', 
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: '30px', marginTop: '40px' }}>
        <h1 style={{ 
          color: '#2c3e50', 
          fontSize: '32px', 
          marginBottom: '12px',
          fontWeight: '700'
        }}>
          Welcome to MindBridge
        </h1>
        <p style={{ 
          color: '#64748b', 
          fontSize: '18px', 
          margin: '0 0 30px 0',
          fontWeight: '400'
        }}>
          Your mental wellness companion
        </p>
        
        <div style={{
          width: '100px',
          height: '100px',
          backgroundColor: '#4361ee',
          borderRadius: '50%',
          margin: '0 auto 20px auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 10px 20px rgba(67, 97, 238, 0.3)'
        }}>
          <span style={{ fontSize: '48px', color: 'white' }}>🌉</span>
        </div>
      </div>

      {/* Value Proposition */}
      <Card style={{ 
        textAlign: 'center', 
        marginBottom: '24px',
        border: '1px solid #e2e8f0'
      }}>
        <h2 style={{ 
          color: '#2c3e50', 
          marginBottom: '16px',
          fontWeight: '600'
        }}>
          Your Journey to Wellness Starts Here
        </h2>
        <p style={{ 
          color: '#64748b', 
          fontSize: '16px',
          lineHeight: '1.6',
          margin: 0
        }}>
          MindBridge provides personalized mental wellness support through AI-powered tools, 
          gamified challenges, and peer connections designed specifically for young people.
        </p>
      </Card>

      {/* Features */}
      <div style={{ marginBottom: '24px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '16px',
          textAlign: 'center',
          fontWeight: '600'
        }}>
          What We Offer
        </h3>
        
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: '1fr', 
          gap: '12px'
        }}>
          {features.map((feature, index) => (
            <Card 
              key={index}
              style={{ 
                display: 'flex', 
                alignItems: 'center',
                padding: '16px',
                border: '1px solid #e2e8f0'
              }}
            >
              <div style={{ 
                fontSize: '24px', 
                marginRight: '16px',
                width: '40px',
                textAlign: 'center'
              }}>
                {feature.icon}
              </div>
              <div>
                <h4 style={{ 
                  color: '#2c3e50', 
                  margin: '0 0 4px 0',
                  fontSize: '16px',
                  fontWeight: '600'
                }}>
                  {feature.title}
                </h4>
                <p style={{ 
                  color: '#64748b', 
                  margin: 0, 
                  fontSize: '14px'
                }}>
                  {feature.description}
                </p>
              </div>
            </Card>
          ))}
        </div>
      </div>

      {/* Benefits of completing onboarding */}
      <Card style={{ 
        backgroundColor: '#f0f9ff',
        border: '1px solid #bae6fd',
        marginBottom: '24px'
      }}>
        <h3 style={{ 
          color: '#0369a1', 
          marginBottom: '12px',
          fontWeight: '600',
          fontSize: '16px'
        }}>
          💡 Complete Your Profile for Personalized Support
        </h3>
        <ul style={{ 
          color: '#0c4a6e', 
          fontSize: '14px',
          margin: '0 0 0 20px',
          padding: 0
        }}>
          <li style={{ marginBottom: '8px' }}>Get tailored wellness recommendations</li>
          <li style={{ marginBottom: '8px' }}>Track your progress over time</li>
          <li style={{ marginBottom: '0' }}>Unlock personalized insights</li>
        </ul>
      </Card>

      {/* CTA */}
      <div style={{ marginTop: 'auto', marginBottom: '20px' }}>
        <Button 
          onClick={() => navigate('/onboarding')}
          variant="primary"
          size="lg"
          style={{ 
            width: '100%',
            padding: '16px',
            fontSize: '18px',
            fontWeight: '600'
          }}
        >
          Complete Your Profile
        </Button>
        
        <div style={{ 
          display: 'flex', 
          gap: '10px',
          marginTop: '12px'
        }}>
          <Button 
            onClick={() => {
              // Set skipped profile
              localStorage.setItem('userProfile', JSON.stringify({
                riskLevel: "moderate",
                recommendations: ["Complete profile for personalized insights", "Try daily check-ins", "Explore wellness resources"],
                skipped: true,
                onboardingDate: new Date().toISOString()
              }));
              navigate('/home');
            }}
            variant="outline"
            size="sm"
            style={{ flex: 1 }}
          >
            Skip for Now
          </Button>
          <Button 
            onClick={() => {
              localStorage.setItem('onboardingReminder', 'true');
              navigate('/home');
            }}
            variant="outline"
            size="sm"
            style={{ flex: 1 }}
          >
            Later
          </Button>
        </div>
        
        <p style={{ 
          color: '#94a3b8', 
          fontSize: '12px', 
          textAlign: 'center',
          marginTop: '16px',
          marginBottom: '0'
        }}>
          Takes less than 2 minutes
        </p>
      </div>
    </div>
  );
}

export default Introduction;